import { get } from 'lodash';
import * as React from 'react';

import { ValidationErrorData } from '../../typings/common';
import { Omit } from '../../typings/utils';
import { TextInputSourceChange } from '../AddressInput/AddressInput';
import {
    DirectFormInput,
    DirectFormInputMaskedTextProps,
    DirectFormInputTextAreaProps,
    DirectFormInputTextProps
} from '../DirectFormInput/DirectFormInput';
import { ErrorItem, ErrorsPresenterContext, ErrorsPresenterContextProps } from '../ErrorsPresenter/ErrorsPresenter';
import { ErrorText, ErrorTextTheme } from '../ErrorText/ErrorText';

export type DirectInputErrorsViewProps = {
    cls?: string;
    path: string;
    notShowTooltip?: boolean;
} & (
    | Omit<DirectFormInputTextProps, 'valid'>
    | Omit<DirectFormInputTextAreaProps, 'valid'>
    | Omit<DirectFormInputMaskedTextProps, 'valid'>);

type DirectInputErrorsViewComponentProps = DirectInputErrorsViewProps & {
    errors: ErrorItem[];
    onErrorsViewMount: (path: string) => void;
    onErrorsViewUnmount: (path: string) => void;
    onClear?: (path: string) => void;
};

class DirectInputErrorsViewComponent extends React.PureComponent<DirectInputErrorsViewComponentProps> {
    componentWillMount() {
        const { onErrorsViewMount, path } = this.props;

        onErrorsViewMount(path);
    }

    componentWillUnmount() {
        const { onErrorsViewUnmount, path } = this.props;

        onErrorsViewUnmount(path);
    }

    render() {
        const { errors } = this.props;

        return (
            <DirectFormInput
                {...this.props}
                errorText={<ErrorText theme={ErrorTextTheme.tooltip} errors={errors as ValidationErrorData[]} />}
                // @ts-ignore https://github.yandex-team.ru/lego/islands/pull/431
                onChange={this.onChange}
                valid={errors.length === 0}
            />
        );
    }

    private onChange = (value: string, input: object, suggest: TextInputSourceChange | null = null) => {
        const { onChange } = this.props;

        this.onClear();

        if (onChange) {
            // @ts-ignore https://github.yandex-team.ru/lego/islands/pull/431
            onChange(value, input, suggest);
        }
    };

    private onClear = () => {
        const { path, onClear } = this.props;

        if (onClear) {
            onClear(path);
        }
    };
}

const EMPTY_INPUT_ERRORS: ErrorItem[] = [];

export const DirectInputErrorsView = React.memo((props: DirectInputErrorsViewProps) => {
    return (
        <ErrorsPresenterContext.Consumer>
            {({ errors, onErrorsViewMount, onErrorsViewUnmount, onClear }: ErrorsPresenterContextProps) => (
                <DirectInputErrorsViewComponent
                    key={props.path}
                    {...props}
                    errors={get(errors, props.path, EMPTY_INPUT_ERRORS)}
                    onClear={onClear}
                    onErrorsViewMount={onErrorsViewMount}
                    onErrorsViewUnmount={onErrorsViewUnmount}
                />
            )}
        </ErrorsPresenterContext.Consumer>
    );
});
